module.exports = __webpack_public_path__ + "img/iphone-x.ff1daa9e.png";